<div
 class="flex flex-row pt-[0.4rem] pb-1 pl-3 pr-3 bg-white rounded-md"
  [ngClass]="{ 'disabled': _location === undefined}">
  <div class="basis-2/3 flex flex-row gap-2">
    <nx-filter-multiSelect
      [(ngModel)] = "statesModel"
      [options]="statesOptions"
      [disabled]="_location === undefined"
      [className]="'table-filter'"
      [filter]="false"
      [showToggleAll]="false"
      [showHeader]="false"
      [appendTo]="'body'"
      [showClear]="true"
      (onChange)="onStateModelChange()"
      (onClear)="onStateModelChange()"
      [placeholder]="'tourPlanningModule.toursPlannerToursMultiComponent.filter.status.placeholder' | translate"
      optionLabel="label">
      <ng-template let-option pTemplate="item">
        <div class="inline-block vertical-align-middle">
          <span class="ml-1 mt-1">{{ option.name }}</span>
        </div>
      </ng-template>
  </nx-filter-multiSelect>
  </div>
  <div class="basis-1/3 flex flex-row justify-end">
    <p-dropdown
      [disabled]="_location === undefined"
      [(ngModel)] = "sortModel"
      [options]="sortOptions"
      (onChange)="onSortModelChange()"
      [placeholder]="'tourPlanningModule.toursPlannerToursMultiComponent.sorting.placeholder' | translate"
      [styleClass]="'sort'"
      appendTo="body"
      optionLabel="label"
      [showClear]="false">
    </p-dropdown>
  </div>
</div>

<div
  #xScrollContainer
  class="flex flex-row gap-4 no-scrollbar mt-2 h-[calc(100%-56px)] overflow-y-hidden overflow-x-auto">
  
  <nx-empty-box
    class="w-full"
    *ngIf="_location === undefined"
    [label]="'tourPlanningModule.toursPlannerToursMultiComponent.emptyState.noLocationSelected' | translate">
  </nx-empty-box>

  <div
    *ngFor="let day of tourDays; trackBy: trackByDay"
    class="flex-shrink-0 min-w-[500px] max-w-[570px]"
    [ngClass]="{
      'min-w-[500px]' : !isReduced(day),
      'max-w-[570px]' : !isReduced(day),
      'expanded' : !isReduced(day),
      'w-[44px]' : isReduced(day),
      'overflow-hidden' : !isReduced(day),
    }">
    <div class="flex flex-row bg-[#EAEEEF] h-12 rounded-t-md">
      <div class="basis-1/3 flex flex-row items-center font-medium"
        [ngClass]="{ 'ml-3' : !isReduced(day)}">
        <ng-container
          *ngIf="!isReduced(day)">
          {{day?.getDate() | date:'EEE, dd.MM.yyyy'}}
        </ng-container>
        <nx-default-button
          class="ml-2"
          *ngIf="isReduced(day)"
          (click)="expand(day)"
          [tooltip]="'tourPlanningModule.toursPlannerToursMultiComponent.tooltip.expandDay' | translate"
          [style]="'light'"
          [icon]="'icon-after'">
        </nx-default-button>
      </div>
      <div class="basis-2/3 flex flex-row justify-end items-center mr-3"
        *ngIf="!isReduced(day)">
        <nx-default-button
          class="ml-2"
          (click)="createTour(day)"
          [disabled]="_location === undefined"
          *ngIf="rolesService?.hasRole('nexcore_tour_create') && !isReduced(day)"
          [tooltip]="'tourPlanningModule.toursPlannerToursMultiComponent.tooltip.createTour' | translate"
          [label]="'tourPlanningModule.toursPlannerToursMultiComponent.button.createTour' | translate"
          [style]="'light'"
          [icon]="'icon-plus'">
        </nx-default-button>
        <nx-default-button
          class="ml-2"
          *ngIf="!isReduced(day)"
          (click)="reduce(day)"
          [tooltip]="'tourPlanningModule.toursPlannerToursMultiComponent.tooltip.reduceDay' | translate"
          [style]="'light'"
          [icon]="'icon-back-to'">
        </nx-default-button>
      </div>
  </div>

    <div #yScrollContainer class="overflow-auto no-scrollbar h-[calc(100%-48px)]" style="overflow-anchor: auto;">

      <ng-container
        *ngIf="!isReduced(day)">
      
        <ng-container
          *ngIf="_location !== undefined && day?.getTourDayEntities()?.length > 0">
          <div
            *ngFor="let entities of day.getTourDayEntities(); trackBy: trackByEntity"
            class="tourGroup unplanned  ">
            <h2 class="text-base font-medium p-2">{{entities?.getName()}}</h2>
            <ng-container *ngIf="entities?.getTours() as tours">
              <div tours-planner-tours-list
                class="toursList"
                [sortBy]="sortModel?.id"
                [tours]="tours"
                (refetch)="refetchQuery()">
              </div>
            </ng-container>
          </div>
        </ng-container>

        <nx-empty-box
          *ngIf="_location !== undefined && day?.getTourDayEntities()?.length === 0"
          [label]="'tourPlanningModule.toursPlannerToursMultiComponent.emptyState.noToursFound' | translate">
        </nx-empty-box>

      </ng-container>

      <ng-container
        *ngIf="isReduced(day)">
        <div class="h-full flex justify-center">
          <div class="border-l border-dashed border-[#c3c3c3]"></div>
        </div>
      </ng-container>

    </div>

  </div>
</div>